import * as React from "react";
import {cx} from "emotion";

import "./step-3-cass-result.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";

import {convertRecords} from "../common/convert-records";
import {Overview}       from "./overview/overview";

export const Step3CassResult = ({data, officeId, fileName, onClose, countryCode}) => cs(
    consumeContext("apis"),
    ["cassData", ({apis}, next) => Load2({
        fetch: () => apis.next.mailing.dnm.addBulkDoNotMailAddress(
            convertRecords({
                modification: data.value.build.modification,
                keys: data.value.build.keys,
                rows: data.value.upload.rows,
                countryCode,
            }).map((r) => r.address),
            officeId,
        ),
        next,
    })],
    ({cassData}, next) => (
        <div className="step-3-cass-result-a7xx">
            <div className="content">
                {next()}
            </div>

            <div className="footer">
                <button {...{
                    className: cx("next", {disabled: cassData.loading}),
                    "xd-qa-type": "button",
                    "xd-qa-name": "CASS Result Close",
                    onClick: async () => onClose(),
                }}>
                    Close
                </button>
            </div>
        </div>
    ),
    ({cassData}) => Overview({
        fileName,
        cass: cassData,
    })
);